import React from 'react';
import { Link } from "react-router-dom";
import Axios from "axios";
import { useState, useEffect } from 'react';
import { useForm ,Controller} from "react-hook-form";
import { yupResolver } from '@hookform/resolvers/yup'
import * as Yup from 'yup'
import Select from 'react-select';
import 'react-toastify/dist/ReactToastify.css';
import { RegisterAPIURL } from '../apiconstants/constants';
import Tooltip from 'react-bootstrap/Tooltip';
import OverlayTrigger from 'react-bootstrap/OverlayTrigger';
import LoadingSpinner from '../helpers/loadingspinner';
import FooterLayout from '../commonlayouts/beforeloginfooter';
import logo from "../assets/images/knackhire-new.png"
import defaultimg from "../assets/images/icons8-circled-user-male-skin-type-3-100.png"
import Swal from 'sweetalert2';
function Register() {

  const formSchema = Yup.object().shape({
    terms: Yup.bool() // use bool instead of boolean
      .oneOf([true], "You must accept the terms and conditions"),
    firstName: Yup.string().required("First Name is required"),
      lastName: Yup.string().required("Last Name is required"),
      CompanyName: Yup.string().required("Company Name is required"),

      mobile: Yup.string().required("Mobile Number is required"),
      email: Yup.string().email().required("Email is required"),
      password: Yup.string()
      .required('Password is mandatory')
      .matches(
        /^(?=.*\d)(?=.*[a-z])(?=.*[A-Z]).{6,15}$/,
        'one Capital,one Small Letter, and one number, characters should be between 6 to 15',
      ),

    confirmPwd: Yup.string()
      .required('Password is mandatory')
      .oneOf([Yup.ref('password')], 'Passwords does not match'),
  })

  const formOptions = { resolver: yupResolver(formSchema) }
  const { register, handleSubmit, reset, formState,control } = useForm(formOptions);
  const { errors } = formState
  const { isSubmitting } = formState;
  const apiUrl = RegisterAPIURL.APIURL;
  const [roleid, setRoleID] = React.useState(2);
  const [isLoading, setIsLoading] = useState(false);
  const clientData = JSON.parse(localStorage.getItem("clientData"));
  const clientName = clientData?.name;
  const [file, setFile] = useState();
  const[fileName,setFileName] = useState(null);
function handleResumeChange(event) {
  const file = event.target.files[0];
  if (!file) return;

  // Sanitize the filename
  const sanitizedFileName = file.name.replace(/[^a-z0-9.]/gi, '_').toLowerCase();

  setFile(file);
  setFileName(sanitizedFileName);

  const fileInput = document.getElementById('LogoURL');
  const filePath = fileInput.value;

  // Allowing file type
  const allowedExtensions = /(\.png|\.jpg|\.jpeg)$/i;

  if (!allowedExtensions.exec(filePath)) {
    Swal.fire({
      text: 'Invalid File Type!',
    });
    fileInput.value = '';
    return false;
  } else {
    return true;
  }
}

  const onSubmit = (data, e) => {
    e.preventDefault();
    e.target.reset();
    setIsLoading(true);

    const formData = new FormData();
    formData.append('firstName', data.firstName);
    formData.append('lastName', data.lastName);
    formData.append('CompanyName', data.CompanyName);
    formData.append('CountryMappings', data.CountryMappings.map(c => c.value));
    formData.append('email', data.email);
    formData.append('mobileNumber', data.mobile);
    formData.append('password', data.password);
    formData.append('employeeGuid', '3fa85f64-5717-4562-b3fc-2c963f66afa6');
    formData.append('LogoURL', file);
    formData.append('roleID', 2);              // Admin
    formData.append('Usertype', null);

    Axios.post(apiUrl, formData)
      .then((result) => {


        setIsLoading(false);
        if (result.data.message === "Success") {
          
          Swal.fire({
            position: 'center',
            icon: 'success',
            title: 'Registration successful, please check your email for verification instructions.',
            showConfirmButton: false,
            timer: 5000
          })
          
          //toast.success('Data Saving', {autoClose:5000})

        }
        else if(result.data.message ==="already registered") {
          Swal.fire({
            position: 'center',
            icon: 'error',
            title: 'Email Already Registered. If you dont know your password please visit the Forgot Password page.',
            showConfirmButton: false,
            timer: 5000
          })
          // toast.error('Issue with data format', {autoClose:5000})
        }
        else {
          Swal.fire({
            position: 'center',
            icon: 'error',
            title: 'Something gone Wrong',
            showConfirmButton: false,
            timer: 5000
          })
        }

      

      }).catch(
        function (error) {
          console.log("Error" + error)
        })

    return new Promise(resolve => {
      setTimeout(() => {
        resolve();
      }, 5000);
    });

  }
  const renderCheckbox = (value, label, imageSrc) => {
    const isSelected = roleid === value;
    const checkboxStyle = isSelected ? { border: '2px solid #00a7ac' } : {};

    return (
      <div
        className="card p-3 text-center"
        style={{ border: 'none', boxShadow: 'none', ...checkboxStyle }}
        onClick={() => setRoleID(isSelected ? '' : value)}
      >
        <img style={{ margin:"auto",width: 60, height: 60 }} src={imageSrc} alt={label} />
        <h5 className="mt-3" style={{ color: '#00a7ac' }}>{label}</h5>
      </div>
    );
  };
  return (
    <>
     <nav class="navbar navbar-light bg-light justify-content-between">
                      <Link to="/home"> <img src={logo} height={50} alt="Logo" />
                      </Link>
                      <div class="bb">
    
                      </div>
                  </nav>
       {isLoading ? (
    <center>
   <LoadingSpinner/>
    </center>
  )  :
   <div class="container mt-5">
     <form onSubmit={handleSubmit(onSubmit)} id="loginform">
    <div class="row" style={{height: "auto"}} >
        <div class="shadow col-md-6 col-xl-6 col-lg-6 col-sm-12 login-logo" style={{backgroundColor:"#00a7ac"}}>
            <div class="text-center " style={{marginTop:300}}>
{/* <img src={logo} style={{height:60}} alt="Logo"/> */}
         
<h1 style={{color:"#fff"}}>{clientName}</h1>
</div>
        </div>
        
        <div class="col-sm-12 col-md-6 col-lg-6 col-xl-6 shadow-sm p-3" >
                <h2 class="text-center " style={{color:"#00a7ac"}}>Register</h2>
                <div className="row mt-1">
                <div className="">
              {renderCheckbox(2, 'Admin', defaultimg)}
            </div>
            {/* <div className="col-sm-12 col-md-6 col-lg-6 col-xl-6">
              {renderCheckbox(5, 'Admin', defaultimg)}
            </div> */}
          </div>
                
                <div class="mb-3 mt-5">
                <OverlayTrigger placement="bottom" overlay={(props) => (<Tooltip id="tooltip" {...props}> First Name</Tooltip>)}>

<input
  placeholder='First Name'
  type="text"
  name="firstName"
  {...register("firstName")}
  className={`form-control shadow-sm ${errors.firstName ? 'is-invalid' : ''}`}

/>
</OverlayTrigger>
<div className="invalid-feedback"> {errors.firstName?.message}</div> 
                  </div>
                  <div class="mb-3 mt-4">
                  <OverlayTrigger placement="bottom" overlay={(props) => (<Tooltip id="tooltip" {...props}> Last Name</Tooltip>)}>
                  <input
                    placeholder='Last Name'
                    type="text"
                    name="lastName"
                    {...register("lastName")}
                    className={`form-control shadow-sm ${errors.lastName ? 'is-invalid' : ''}`}
                  />
                </OverlayTrigger>
                     <div className="invalid-feedback"> {errors.lastName?.message}</div>  
                </div>
                 <div class="mb-3 mt-4">
                <OverlayTrigger placement="bottom" overlay={(props) => (<Tooltip id="tooltip" {...props}> Company Name</Tooltip>)}>

<input
  placeholder='Company Name'
  type="text"
  name="CompanyName"
  {...register("CompanyName")}
  className={`form-control shadow-sm ${errors.CompanyName ? 'is-invalid' : ''}`}

/>
</OverlayTrigger>
<div className="invalid-feedback"> {errors.CompanyName?.message}</div> 
                  </div>
           
                  
                  <div class="mb-3 mt-4">
                  <OverlayTrigger placement="bottom" overlay={(props) => (<Tooltip id="tooltip" {...props}> Email</Tooltip>)}>
                  <input
                    placeholder='Email'
                    type="email"
                    name="email"
                    {...register("email")}
                    className={`form-control shadow-sm ${errors.email ? 'is-invalid' : ''}`}

                  />
                </OverlayTrigger>
                <div className="invalid-feedback"> {errors.email?.message}</div>
                    </div>

                    <div class="mb-3 mt-4">
                    <OverlayTrigger placement="bottom" overlay={(props) => (<Tooltip id="tooltip" {...props}> Mobile Number</Tooltip>)}>
                  <input
                    placeholder='Mobile Number'
                    type="text"
                    name="mobile"
                    {...register("mobile")}
                    className={`form-control shadow-sm ${errors.mobile ? 'is-invalid' : ''}`}

                  />
                </OverlayTrigger>
                <div className="invalid-feedback"> {errors.mobile?.message}</div>
                    </div>

                  
                   

                    <div class="mb-3 mt-4">
                    <OverlayTrigger placement="bottom" overlay={(props) => (<Tooltip id="tooltip" {...props}> Password</Tooltip>)}>
                  <input
                    placeholder='Password'
                    type="password"
                    name="password"
                    {...register("password")}
                    className={`form-control shadow-sm ${errors.password ? 'is-invalid' : ''}`}

                  />
                </OverlayTrigger>

                <div className="invalid-feedback">{errors.password?.message}</div>
                    </div>

                    <div class="mb-3 mt-4">
                    <OverlayTrigger placement="bottom" overlay={(props) => (<Tooltip id="tooltip" {...props}>  Confirm Password</Tooltip>)}>
                  <input
                    name="confirmPwd"
                    type="password"
                    placeholder="Enter your Confirm password"
                    {...register('confirmPwd')}
                    className={`form-control shadow-sm${errors.confirmPwd ? 'is-invalid' : ''}`}
                  />
                </OverlayTrigger>
                <div className="invalid-feedback">{errors.confirmPwd?.message}</div>
                    </div>

<div className="mt-4 mb-3">
  <Controller
    name="CountryMappings"
    control={control}
    rules={{ required: "At least one country must be selected" }}
    render={({ field }) => (
      <Select 
        {...field}
        options={[
          { value: "1", label: "India" },
          { value: "2", label: "United States" }
        ]}
        isMulti
        placeholder="Select Country"
        styles={{
          control: (provided) => ({
            ...provided,
            minHeight: 50,
            borderRadius: 15,
            borderColor: errors.CountryMappings ? 'red' : provided.borderColor,
          }),
          placeholder: (provided) => ({
            ...provided,
            fontSize: '12px', // 👈 Smaller font size
            color: '#999',     // Optional: lighter color for placeholder
          }),
          menu: (provided) => ({
            ...provided,
            fontSize: '12px',
          }),
          option: (provided) => ({
            ...provided,
            fontSize: '12px',
          }),}}
        className={` basic-form ${errors.CountryMappings ? 'is-invalid' : ''}`}
        onChange={(selectedOptions) => {
          field.onChange(selectedOptions);
        }}
      />
    )}
  />
  {errors.CountryMappings && (
    <div className="invalid-feedback d-block">{errors.CountryMappings.message}</div>
  )}
</div>

    <div class="mb-3 mt-4">
                                    <OverlayTrigger placement="bottom"  overlay={(props) => (<Tooltip id="tooltip" {...props}>  Upload Logo (Filename should not contain spaces or special characters)</Tooltip>)}>    
                    
                    <input style={{ height:38 }} {...register("LogoURL", { required: "LogoURL required" })}  name="LogoURL" id="LogoURL" type="file" className={`form-control basic-form mt-3${errors.LogoURL ? 'is-invalid' : ''}`} accept=".png, .jpg, .jpeg"  onChange={handleResumeChange}   />
                    </OverlayTrigger>
                    {fileName && <div style={{fontSize : 13}}> {fileName}</div>}
                   
                    <div className="invalid-feedback">{errors.LogoURL?.message}</div> </div>
                    

                   <div className='text-center'>
                  <button disabled={isSubmitting} class="btn btn-primary " style={{backgroundColor:"#00a7ac",border:"none",borderRadius: 15}}>
                  {isSubmitting && <span className="spinner-border spinner-border-sm mr-1"></span>}
                  Sign Up
                </button> 
               <Link to={`/home`}> <button  class="btn btn-primary " style={{backgroundColor:"#00a7ac",border:"none",borderRadius: 15}}>
    
                 Cancel
                </button>
                </Link>

                </div> 
        </div>
        </div>
        </form>
   </div>
}
    <div className='mt-5'>
    <FooterLayout/>
    </div>
    </>


  )
}

export default Register;